import { useReactFlow } from "@xyflow/react";
import { DRAFT_NODE_ID } from "features/entities/EntityCreatePage/EntityGraph/entityGraphConstants";
import { useFitViewWithDelay } from "features/entities/EntityCreatePage/EntityGraph/hooks/useFitViewWithDelay";
import { DraftNode } from "features/entities/EntityCreatePage/EntityGraph/nodes/types";
import maxBy from "lodash-es/maxBy";
import minBy from "lodash-es/minBy";
import { useCallback } from "react";

export const useAddDraftNode = () => {
  const { addNodes, getNodes } = useReactFlow();

  const fitViewWithDelay = useFitViewWithDelay();

  const addDraftNode = useCallback(() => {
    const nodes = getNodes();
    const x = minBy(nodes, (node) => node.position.x)!.position.x - 100;
    const y = maxBy(nodes, (node) => node.position.y)!.position.y + 50;

    const newNode: DraftNode = {
      id: DRAFT_NODE_ID, // there can only be the one, using the same id enforces this
      position: { x, y },
      data: {},
      type: "draft",
    };

    addNodes(newNode);
    fitViewWithDelay();
  }, [addNodes, fitViewWithDelay, getNodes]);
  return addDraftNode;
};
